import { Sun, Moon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { choiceTheme } from '../../slices/authSlice';
import { useDispatch } from 'react-redux';
import { ListItem, Typography } from '@material-tailwind/react';

const ThemeMode = () => {
  const [theme, setTheme] = useState(localStorage.getItem('theme') === 'dark');
  const dispatch = useDispatch();

  useEffect(() => {
    const root = document.documentElement;
    if (theme) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.removeItem('theme');
    }
    dispatch(choiceTheme());
  }, [theme]);
  const handleTheme = () => {
    setTheme((prev) => (prev ? '' : 'dark'));
  };
  return (
    <>
      <ListItem
        className="hover:bg-transparent focus:bg-transparent space-x-2"
        onClick={handleTheme}
      >
        <div className="cursor-pointe bg-blue-900 border  rounded-full p-2 w-full flex gap-2">
          {theme && <Sun className="h-5 w-5 cursor-pointer" color="white" />}
          {!theme && <Moon className="h-5 w-5 " color="white" />}
          <Typography className="font-bold text-black dark:text-darkText">
            {theme ? 'MODO CLARO' : 'MODO ESCURO'}
          </Typography>
        </div>
      </ListItem>
    </>
  );
};

export default ThemeMode;
